/**
 * DO NOT EDIT THIS FILE DIRECTLY
 * This file generated by fast-components/build/generate-default-palettes.js
 */
export const neutralPalette = [
    "#FFFFFF",
    "#FCFCFC",
    "#FAFAFA",
    "#F7F7F7",
    "#F5F5F5",
    "#F2F2F2",
    "#EFEFEF",
    "#EDEDED",
    "#EAEAEA",
    "#E8E8E8",
    "#E5E5E5",
    "#E2E2E2",
    "#E0E0E0",
    "#DDDDDD",
    "#DBDBDB",
    "#D8D8D8",
    "#D6D6D6",
    "#D3D3D3",
    "#D0D0D0",
    "#CECECE",
    "#CBCBCB",
    "#C9C9C9",
    "#C6C6C6",
    "#C3C3C3",
    "#C1C1C1",
    "#BEBEBE",
    "#BCBCBC",
    "#B9B9B9",
    "#B6B6B6",
    "#B4B4B4",
    "#B1B1B1",
    "#AFAFAF",
    "#ACACAC",
    "#A9A9A9",
    "#A7A7A7",
    "#A4A4A4",
    "#A2A2A2",
    "#9F9F9F",
    "#9D9D9D",
    "#9A9A9A",
    "#979797",
    "#959595",
    "#929292",
    "#909090",
    "#8D8D8D",
    "#8A8A8A",
    "#888888",
    "#858585",
    "#838383",
    "#808080",
    "#7D7D7D",
    "#7B7B7B",
    "#787878",
    "#767676",
    "#737373",
    "#717171",
    "#6E6E6E",
    "#6B6B6B",
    "#696969",
    "#666666",
    "#646464",
    "#616161",
    "#5F5F5F",
    "#5C5C5C",
    "#5A5A5A",
    "#575757",
    "#545454",
    "#525252",
    "#4F4F4F",
    "#4D4D4D",
    "#4A4A4A",
    "#484848",
    "#454545",
    "#424242",
    "#404040",
    "#3D3D3D",
    "#3B3B3B",
    "#383838",
    "#363636",
    "#333333",
    "#313131",
    "#2E2E2E",
    "#2B2B2B",
    "#292929",
    "#262626",
    "#242424",
    "#212121",
    "#1E1E1E",
    "#1B1B1B",
    "#181818",
    "#151515",
    "#121212",
    "#101010",
    "#000000"
];
export const accentPalette = [
    "#FFFFFF",
    "#FEFBFC",
    "#FEF7FA",
    "#FDF4F7",
    "#FDF0F5",
    "#FCECF2",
    "#FBE8EF",
    "#FBE5ED",
    "#FAE1EA",
    "#FADDE7",
    "#F9D9E5",
    "#F8D6E2",
    "#F8D2E0",
    "#F7CEDD",
    "#F7CADA",
    "#F6C7D8",
    "#F5C3D5",
    "#F5BFD2",
    "#F4BBD0",
    "#F3B8CD",
    "#F3B4CB",
    "#F2B0C8",
    "#F2ACC5",
    "#F1A9C3",
    "#F0A5C0",
    "#F0A1BD",
    "#EF9DBB",
    "#EF9AB8",
    "#EE96B6",
    "#ED92B3",
    "#ED8EB0",
    "#EC8BAE",
    "#EC87AB",
    "#EB83A8",
    "#EA7FA6",
    "#EA7CA3",
    "#E978A1",
    "#E9749E",
    "#E8709B",
    "#E76D99",
    "#E76996",
    "#E66593",
    "#E66191",
    "#E55E8E",
    "#E45A8C",
    "#E45689",
    "#E35286",
    "#E24F84",
    "#E24B81",
    "#E1477E",
    "#E1437C",
    "#E04079",
    "#DF3C77",
    "#DF3874",
    "#DE3471",
    "#DE316F",
    "#DD2D6C",
    "#DC2969",
    "#DC2567",
    "#DB2264",
    "#DB1E62",
    "#DA1A5F",
    "#D4195C",
    "#CD1859",
    "#C71857",
    "#C01754",
    "#BA1651",
    "#B3154E",
    "#AD154B",
    "#A71449",
    "#A01346",
    "#9A1243",
    "#931240",
    "#8D113D",
    "#86103B",
    "#800F38",
    "#7A0F35",
    "#730E32",
    "#6D0D2F",
    "#660C2D",
    "#600B2A",
    "#590B27",
    "#530A24",
    "#4D0921",
    "#46081F",
    "#40081C",
    "#3B071A",
    "#350617",
    "#300615",
    "#2B0513",
    "#260511",
    "#21040E",
    "#1C030C",
    "#000000"
];
